import React from 'react';

const Author = ({ author }) => {
  if (author) return <h2 className="author-filtered">Posts by {author?.name || author[0]?.name}</h2>;
  return null;
};

export default Author;
